module.exports = __webpack_public_path__ + "static/databox-0e51a3649deddf03684ef083577e3eea.png";